import { useContext, useEffect } from 'react';
import SectionWrapper from '@/home/common/SectionWrapper';
import SRPLinks from '@/home/ReturnUser/HeroCards/LinkCards/SRPLinks';
import OrderState from '~/constants/common/OrderState';
import { useIsLoggedIn } from '~/context/common/UserContext';
import GlobalContext from '~/context/home/GlobalContext';
import { useGetUserPurchase } from '~/context/home/UserPurchaseContext';
import { TradeCard, FinanceCard } from './Cards';
import {
  FinanceTradeWrapper,
  GridWrapper,
  HeroFavoriteAndSearchCard
} from './HeroCards.styles';
import VDPLinks from './LinkCards/VDPLinks';
import OrderStatusCardMapper from './OrderStatusCardMapper/OrderStatusCardMapper';

export default function HeroCards() {
  const {
    isLoaded,
    data: { orderState }
  } = useGetUserPurchase();
  const isLoggedIn = useIsLoggedIn();
  const { setIsVdpLinksLoaded } = useContext(GlobalContext);
  const shouldShowPurchaseCard =
    isLoggedIn && isLoaded && orderState !== OrderState.None;

  useEffect(() => {
    if (shouldShowPurchaseCard) {
      setIsVdpLinksLoaded(true);
    }
  }, [setIsVdpLinksLoaded, shouldShowPurchaseCard]);

  return (
    <SectionWrapper
      analyticsSection="Hero Cards"
      hasSideSpacing
      hasBottomSpacing
      className="mt-[-40px] md:mt-[-60px]"
    >
      <div className="flex w-full flex-col gap-2xl">
        {shouldShowPurchaseCard && <OrderStatusCardMapper />}

        <GridWrapper data-testid="link-card-container">
          <HeroFavoriteAndSearchCard>
            <VDPLinks />
          </HeroFavoriteAndSearchCard>
          <HeroFavoriteAndSearchCard>
            <SRPLinks />
          </HeroFavoriteAndSearchCard>

          <FinanceTradeWrapper>
            <FinanceCard />
            <TradeCard />
          </FinanceTradeWrapper>
        </GridWrapper>
      </div>
    </SectionWrapper>
  );
}
